<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <ValidationObserver ref="formObserver" v-slot="{ invalid, validate }">
                    <b-form @submit.prevent="handleSubmit(validate)">
                      <div class="form-row">
                        <div class="form-group col-md-6">
                          <ValidationProvider name="Title" rules="required" v-slot="{ errors }">
                            <label for="Name">
                              <span class="required">*</span> {{ $t('Title') }}:
                            </label>
                            <b-form-input
                                id="Title"
                                type="text"
                                v-model="origin.title"
                                :state="errors.length ? false : null"
                                placeholder=""
                            />
                            <b-form-invalid-feedback :state="errors.length">{{
                                $t(errors[0])
                              }}
                            </b-form-invalid-feedback>
                          </ValidationProvider>
                        </div>
                        <div class="form-group col-md-6">
                          <ValidationProvider name="Description" rules="required" v-slot="{ errors }">
                            <label for="Description">
                              <span class="required">*</span> {{ $t('Description') }}:
                            </label>
                            <b-form-input
                                id="Description"
                                type="text"
                                v-model="origin.description"
                                :state="errors.length ? false : null"
                                placeholder=""
                            />
                            <b-form-invalid-feedback :state="errors.length">{{
                                $t(errors[0])
                              }}
                            </b-form-invalid-feedback>

                          </ValidationProvider>
                        </div>
                        <div class="form-group col-md-6">
                          <ValidationProvider name="Order" rules="required" v-slot="{ errors }">
                            <label for="order">
                              <span class="required">*</span> {{ $t('Order') }}:
                            </label>
                            <b-form-input
                                id="order"
                                type="number"
                                v-model="origin.order"
                                :state="errors.length ? false : null"
                                placeholder=""
                            />
                            <b-form-invalid-feedback :state="errors.length">{{
                                $t(errors[0])
                              }}
                            </b-form-invalid-feedback>
                          </ValidationProvider>
                        </div>
                      </div>
                      <span class="required_fields">
                        <span class="required">*</span>
                        <strong>{{ $t('Required Fields') }}</strong>
                      </span>
                      <div class="block text-right">
                        <b-button variant="outline-secondary" class="btn btn-back" @click="$router.go(-1)">
                          <i class="fa fa-arrow-left"></i> {{ $t('To Go Back') }}
                        </b-button>

                        <b-button type="submit" variant="primary" class="ml-1">
                          {{ $t('Save') }}
                          <i class="fa fa-save"></i>
                        </b-button>
                      </div>
                    </b-form>
                  </ValidationObserver>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import vSelect from "vue-select";
import AddressAutocomplete from "../../layouts/Mapa/AddressAutocomplete";
import AddToList from "../../layouts/components/AddToList";
import {ValidationObserver, ValidationProvider, extend} from "vee-validate";
import {required, email} from "vee-validate/dist/rules";
import {BButton, BForm, BFormInput, BFormGroup, BFormSelect, BFormInvalidFeedback} from "bootstrap-vue";

// Add the rules to vee-validate
extend("required", required);

export default {
  name: "originForm",
  components: {
    BaseCrud,
    vSelect,
    AddressAutocomplete,
    AddToList,
    ValidationObserver,
    ValidationProvider,
    BButton,
    BForm,
    BFormInput,
    BFormGroup,
    BFormSelect,
    BFormInvalidFeedback,
  },
  data() {
    return {
      origin: {
        title: '',
        description: '',
        order: '',
      },
      errors: undefined,
    };
  },
  methods: {
    async handleSubmit(validate) {
      const isValid = await validate();
      if (isValid) {
        this.save();
      }
    },
    save() {
      let api = this.$store.state.api + "origins";

      if (this.origin.id) {
        this.origin._method = "PUT";
        api += "/" + this.origin.id;
      }

      axios
          .post(api, this.origin)
          .then((response) => {
            if (!this.origin.id && response.data && response.data.id) {
              this.origin = response.data
            }
            this.$message(
                this.$t('Success'),
                this.$t('Information saved successfully'),
                "success"
            );
            this.$router.push("/origins");
          })
          .catch((error) => {
            this.$error(error);
          });
    },
    getOrigin(id) {
      let api = this.$store.state.api + "origins/" + id;

      axios
          .get(api)
          .then((response) => {
            this.origin = response.data.data[0];
          })
          .catch((error) => {
            this.$error(error);
          });
    },
  },
  mounted() {
    const id = this.$route.params.id;
    if (id) {
      this.getOrigin(id);
    }
  },
};
</script>

<style scoped>

.btn-user:hover,
.btn-user[aria-expanded="true"] {
  background: linear-gradient(to right, #000, #666);
  color: #fff !important;
}
</style>
